export const LOOKUP_FILTER_GROUP = {
    KEYWORDS: 'keyword',
    COMMON: 'common',
    CONNECTED: 'connected',
    AUDIENCE: 'audience_insights',
};
export const NETWORKS_INSIGHTS_SUPPORTED_BY_IQ_SOCIAL = ['instagram', 'youtube', 'tiktok'];

export const PUBLIC_SOURCE_INFLUENCERS_MAX_COUNT = 10000;
